"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _studentTheme = require("@eduact/student-theme");
var _edSystem = require("@eduact/ed-system");
var _Feedback = require("../../Feedback");
var _edComponents = require("@eduact/ed-components");
var _Spacer = _interopRequireDefault(require("../../Spacer"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var theme = (0, _studentTheme.createTheme)({});
var AnswerAttachments = function AnswerAttachments(_ref) {
  var answer = _ref.answer;
  var attachments = (0, _react.useMemo)(function () {
    var _answers = JSON.parse(answer);
    return _answers.map(function (_) {
      return {
        url: _,
        type: _.split('.').pop()
      };
    });
  }, [answer]);
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var _useState3 = (0, _react.useState)(),
    _useState4 = _slicedToArray(_useState3, 2),
    attachment = _useState4[0],
    setAttachment = _useState4[1];
  var handleOpenAttachment = function handleOpenAttachment(attachment) {
    setAttachment(attachment);
    setIsOpen(true);
  };
  var handleCloseAttachment = function handleCloseAttachment() {
    setAttachment(undefined);
    setIsOpen(false);
  };
  return /*#__PURE__*/_react["default"].createElement(_studentTheme.ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/_react["default"].createElement(_Feedback.Dialog, {
    onClose: handleCloseAttachment,
    maxWidth: "xl",
    open: isOpen
  }, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, attachment && /*#__PURE__*/_react["default"].createElement("div", null, _edComponents.imageTypes.includes(attachment.type) && /*#__PURE__*/_react["default"].createElement("img", {
    src: attachment.url,
    alt: ""
  }), _edComponents.docsTypes.includes(attachment.type) && /*#__PURE__*/_react["default"].createElement("object", {
    style: {
      width: '90vw',
      height: '90vh'
    },
    data: attachment.url,
    datatype: "application/pdf"
  }, /*#__PURE__*/_react["default"].createElement("iframe", {
    width: '100%',
    height: '100%',
    src: attachment.url,
    title: "Pdf"
  }))))), /*#__PURE__*/_react["default"].createElement(_Spacer["default"], {
    mb: {
      sm: '6px',
      lg: '1.5rem'
    }
  }), /*#__PURE__*/_react["default"].createElement(_edSystem.FlexLayout, {
    gridGap: '1rem',
    marginTop: '1rem',
    flexWrap: "wrap"
  }, attachments === null || attachments === void 0 ? void 0 : attachments.map(function (attachment) {
    return /*#__PURE__*/_react["default"].createElement(_edComponents.Attachment, {
      onClick: handleOpenAttachment,
      type: attachment.type,
      url: attachment.url,
      withDelete: false
    });
  })));
};
var _default = AnswerAttachments;
exports["default"] = _default;